@if (type === 'boolean') {
  <mat-checkbox [ngModel]="value" (ngModelChange)="valueChange.next($event)" />
} @else if (type === 'string') {
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Value</mat-label>
    <input matInput type="text" [ngModel]="value" (ngModelChange)="valueChange.next($event)" />
  </mat-form-field>
} @else if (type === 'enum') {
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Value</mat-label>
    <mat-select [ngModel]="value" (ngModelChange)="valueChange.next($event)">
      @for (option of enumOptions ?? []; track option.value) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
} @else if (type === 'number') {
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Value</mat-label>
    <input matInput type="number" [ngModel]="value" (ngModelChange)="valueChange.next($event)" />
  </mat-form-field>
} @else {
  <em>Unknown value type '{{type}}'</em>
}